import React from 'react';
import InstructionsSection from './InstructionsSection';
import TextBlockInput from './TextBlockInput';
import SignatureSection from './SignatureSection';

// Skeleton loader for text block inputs
function TextBlockSkeleton() {
  return (
    <div className="animate-pulse space-y-2">
      <div className="h-4 bg-gray-200 rounded w-24"></div>
      <div className="h-10 bg-gray-200 rounded"></div>
      <div className="flex gap-2">
        <div className="h-9 bg-gray-200 rounded w-20"></div>
        <div className="h-9 bg-gray-200 rounded w-20"></div>
      </div>
    </div>
  );
}

// Skeleton loader for signature section
function SignatureSkeleton() {
  return (
    <div className="animate-pulse space-y-3">
      <div className="h-4 bg-gray-200 rounded w-32"></div>
      <div className="h-10 bg-gray-200 rounded"></div>
      <div className="grid grid-cols-2 gap-2">
        <div className="h-20 bg-gray-200 rounded"></div>
        <div className="h-20 bg-gray-200 rounded"></div>
      </div>
      <div className="h-10 bg-gray-200 rounded"></div>
    </div>
  );
}

function SigningSidebar({
  instructionsExpanded,
  onToggleInstructions,
  documentName,
  textBlocks,
  isLoadingFields,
  onTextBlockValueChange,
  onTextBlockPlace,
  onTextBlockReset,
  queuePlacementForBlock,
  typedName,
  typedTemplates,
  typedSelectedTemplate,
  onTypedNameChange,
  onTemplateSelect,
  signaturePosition,
  hasSignatureImage,
  onPlaceSignature,
  onResetSignature,
  isSignatureRequired = false,
}) {
  return (
    <div className="w-full lg:w-[380px] xl:w-[420px] 2xl:w-[480px] lg:border-t-0 lg:border-l border-gray-200 bg-slate-50 flex flex-col overflow-hidden flex-shrink-0 lg:h-full">
      <div
        className="flex-1 overflow-y-auto p-3 sm:p-4 lg:p-5 thin-scrollbar"
        style={{
          scrollbarWidth: 'thin',
          scrollbarColor: '#cbd5e1 #f1f5f9',
          overflowY: 'auto',
        }}
      >
        <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-4 lg:p-5">
          <InstructionsSection
            isExpanded={instructionsExpanded}
            onToggle={onToggleInstructions}
            documentName={documentName}
          />

          <div className="mb-5 space-y-2 mt-6" data-tour="document-fields-section">
            <div className="mb-2">
              <h3 className="text-sm font-semibold text-gray-900">Document Fields</h3>
            </div>
            {isLoadingFields ? (
              <>
                <TextBlockSkeleton />
                <TextBlockSkeleton />
                <TextBlockSkeleton />
              </>
            ) : textBlocks.length > 0 ? (
              textBlocks.map((block) => (
                <TextBlockInput
                  key={block.id}
                  block={block}
                  onValueChange={onTextBlockValueChange}
                  onPlace={onTextBlockPlace}
                  onReset={onTextBlockReset}
                  queuePlacementForBlock={queuePlacementForBlock}
                />
              ))
            ) : (
              <div className="text-sm text-gray-500 italic py-2">
                No document fields required for this document.
              </div>
            )}
          </div>

          {isSignatureRequired && (
            isLoadingFields ? (
              <SignatureSkeleton />
            ) : (
              <SignatureSection
                typedName={typedName}
                typedTemplates={typedTemplates}
                typedSelectedTemplate={typedSelectedTemplate}
                onNameChange={onTypedNameChange}
                onTemplateSelect={onTemplateSelect}
                signaturePosition={signaturePosition}
                hasSignatureImage={hasSignatureImage}
                onPlaceSignature={onPlaceSignature}
                onResetSignature={onResetSignature}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
}

export default SigningSidebar;

